import { css } from "@emotion/react";
import {
  colors,
  borders,
  timings,
  breakpoints,
} from "@mytutor/shared-react-web-components/lib/theme";

export const subjectPickerDropdownStyles = css`
  .option-image {
    height: 1.5em;
    width: 1.5em;
    margin-inline-end: 1em;
    vertical-align: middle;
  }
  .option-image + span {
    vertical-align: middle;
  }
  .option {
    height: 2.2em;
    line-height: 2.2em;
  }
  .dropdown-image {
    height: 1.1em;
    width: 1.1em;
    margin-block-start: 0.3em;
    margin-inline-end: 1em;
  }
`;

export const customStyles = {
  container: (base) => ({
    ...base,
    borderRadius: `${borders.radius}`,
    outline: 1,
    caretColor: `${colors.primary5}`,
    fontWeight: 500,
  }),

  indicatorSeparator: () => ({ display: "none" }),

  option: (base, state) => ({
    ...base,
    backgroundColor: `${
      state.isFocused
        ? colors.neutral2 + "7F"
        : state.isSelected
        ? colors.primary5
        : colors.neutral1
    }`,

    color: `${
      state.isFocused
        ? colors.primary5
        : state.isSelected
        ? colors.neutral1
        : colors.neutral8
    }`,
    "@media only screen and (max-width: 480px)": {
      backgroundColor: state.isFocused
        ? colors.neutral1
        : state.isSelected
        ? colors.primary5
        : colors.neutral1,
      color: state.isFocused
        ? colors.neutral8
        : state.isSelected
        ? colors.neutral1
        : colors.neutral8,
    },
    transition: `background-color ${timings.quick}`,
  }),

  control: (base, state) => ({
    ...base,
    minHeight: 48, // to override the base style min-height :/
    boxShadow: state.isFocused ? `0 0 5px transparent` : 0,
    backgroundColor: `${colors.neutral1}`,
    transition: `border ${timings.medium}`,
    borderRadius: `${borders.radius}`,
    "&:hover": {
      borderColor: `${colors.primary7}`,
    },
  }),

  menu: (styles) => ({
    ...styles,
    boxShadow: "0 8px 16px 0 rgba(24, 19, 87, 0.07)",
    backgroundColor: colors.neutral1,
    borderRadius: `${borders.radius}`,
    border: "0px",
    padding: "0px",
    margin: breakpoints.phone ? "10px 0px 0px 0px" : "0",
    zIndex: 999,
  }),
};
